
// react
import { React, useState } from 'react';

//primereact
import { TabView, TabPanel } from 'primereact/tabview';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';

// components seplag
import RotuloSeplag from '../../components/RotuloSeplag';
import ModalSeplag from './../../components/ModalSeplag/index';

// global

const Modalconsultarcertidoeslegadas = ({ show, setShow, view, rowData }) => {

  // FUNÇÃO PARA FECHAR MODAL
  function closeModal() {
    setShow(false)
  }

  return (
    <ModalSeplag
      titulo={view ? "Detalhes Certidão de Crédito" : 'Filtrar Certidões Legadas para imprimir ou exportar'}
      visible={show}
      fechar={closeModal}
      type={view ? "CLOSE" : "SEARCH"}
      tamanho="800px"
    >
      <div style={{ flex: 1 }}>

        <TabView style={{ width: '100%' }}>
          <TabPanel header="Titular">
            <div className='p-grid p-fluid' >
              <RotuloSeplag nome="Beneficiário" cols="12 4">
                <InputText
                  name="nomeAbreviadoCs"
                  id='nomeAbreviadoCs'
                  value={rowData.nomeAbreviadoCs}
                  disabled
                />
              </RotuloSeplag>
              <RotuloSeplag nome="CPF" cols="12 4">
                <InputNumber
                  name="numrCpfCs"
                  id='numrCpfCs'
                  value={rowData.numrCpfCs}
                  disabled
                />
              </RotuloSeplag>
              <RotuloSeplag nome="Matrícula" cols="12 4" >
                <InputNumber
                  id='numrMatriculaPessoalCs'
                  name="numrMatriculaPessoalCs"
                  value={rowData.numrMatriculaPessoalCs}
                  disabled
                />
              </RotuloSeplag>
            </div>
          </TabPanel>
          <TabPanel header="Certidão de Crédito">
            <div className='p-grid p-fluid'>
              <RotuloSeplag nome="Nº Certidão de Crédito" cols="12 6" >
                <InputNumber
                  name="numrCert"
                  id='numrCert'
                  value={rowData.numrCert}
                  disabled
                />
              </RotuloSeplag>
              <RotuloSeplag nome="Código Tipo" cols="12 6" >
                <InputNumber
                  name="codgTipoCertidao"
                  id='codgTipoCertidao'
                  value={rowData.codgTipoCertidao}
                  disabled
                />
              </RotuloSeplag>
              {view &&
                <>
                  <RotuloSeplag nome="Tipo de Certidão de Crédito" cols="12 6">
                    <InputText
                      id='tipoCertidao'
                      name="tipoCertidao"
                      value={rowData.tipoCertidao}
                      disabled
                    />
                  </RotuloSeplag>
                  {/* <RotuloSeplag nome="Número Sequencial da Certidão" cols="12 6" >
                    <InputNumber
                      id='numrSeqCertidao'
                      name="numrSeqCertidao"
                      value={rowData.numrSeqCertidao}
                      disabled
                    />
                  </RotuloSeplag> */}
                  {/* <RotuloSeplag nome="Código Situação Certidão" cols="12 6" >
                    <InputNumber
                      id='codgSituacaoCert'
                      name="codgSituacaoCert"
                      value={rowData.codgSituacaoCert}
                      disabled
                    />
                  </RotuloSeplag> */}
                  <RotuloSeplag nome="Data de Entrega da Certidão de Crédito" cols="12 6">
                    <InputMask
                      id='dataEntregaCert'
                      mask="99/99/9999"
                      slotChar="mm/dd/yyyy"
                      value={rowData.dataEntregaCert}
                      disabled
                    />
                  </RotuloSeplag>
                  <RotuloSeplag nome="Data de Emissão da Certidão de Crédito" cols="12 6">
                    <InputMask
                      id='dataEmissaoCert'
                      mask="99/99/9999"
                      slotChar="mm/dd/yyyy"
                      value={rowData.dataEmissaoCert}
                      disabled
                    />
                  </RotuloSeplag>
                  <RotuloSeplag nome="Data de Quitação da Certidão de Crédito" cols="12 6">
                    <InputMask
                      id='dataQuitacaoCert'
                      mask="99/99/9999"
                      slotChar="mm/dd/yyyy"
                      value={rowData.dataQuitacaoCert}
                      disabled
                    />
                  </RotuloSeplag>
                  <RotuloSeplag nome="Data de Compensação da Certidão de Crédito" cols="12 6">
                    <InputMask
                      id='dataCompensCert'
                      mask="99/99/9999"
                      slotChar="mm/dd/yyyy"
                      value={rowData.dataCompensCert}
                      disabled
                    />
                  </RotuloSeplag>
                  <RotuloSeplag nome="Nº Processo de Emissão da Certidão de Crédito" cols="12 6" >
                    <InputNumber
                      id='numrEmissaoCert'
                      name="numrEmissaoCert"
                      value={rowData.situacaoCertidado}
                      disabled
                    />
                  </RotuloSeplag>
                </>
              }
            </div>
          </TabPanel>
          <TabPanel header="Valores">
            <div className='p-grid p-fluid'>
              {view &&
                <>
                  <RotuloSeplag nome="Valor Bruto" cols="12 4" >
                    <InputNumber
                      id='valrBruto'
                      name="valrBruto"
                      value={rowData.valrBruto}
                      disabled
                    />
                  </RotuloSeplag>
                  <RotuloSeplag nome="Valor Desconto" cols="12 4" >
                    <InputNumber
                      id='valrDesconto'
                      name="valrDesconto"
                      value={rowData.valrDesconto}
                      disabled
                    />
                  </RotuloSeplag>
                  <RotuloSeplag nome="Valor Líquido" cols="12 4" >
                    <InputNumber
                      id='valrLiquido'
                      name="valrLiquido"
                      value={rowData.valrLiquido}
                      disabled
                    />
                  </RotuloSeplag>
                  <RotuloSeplag nome="Valor Honorário" cols="12 4" >
                    <InputNumber
                      id='valrHonorAdvServ'
                      name="valrHonorAdvServ"
                      value={rowData.valrHonorAdvServ}
                      disabled
                    />
                  </RotuloSeplag>
                </>
              }
            </div>
          </TabPanel>
        </TabView>
      </div>
    </ModalSeplag>
  );
}

export default Modalconsultarcertidoeslegadas;


